import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import dayjs from "dayjs";
import { IDealCryptoGraph } from "store/types";

interface ILineChartProps {
  data: IDealCryptoGraph[];
}

export const LineChart: React.FC<ILineChartProps> = ({ data }) => {
  const formattedValue = (value: number) => {
    const precision: number = 2;
    if (value < 0.01) {
      return value;
    }
    const multiplier = Math.pow(10, precision); // 10^2 = 100
    const roundedValue = Math.floor(value * multiplier) / multiplier;
    return String(roundedValue).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const getYAxisOptions = (data: IDealCryptoGraph[]) => {
    const prices = data.map((item) => parseFloat(item.price));
    const maxPrice = Math.max(...prices);
    const minPrice = Math.min(...prices);

    // let tickInterval: number;
    // if (maxPrice <= 1) {
    //   tickInterval = 0.001;
    // }
    // if (maxPrice <= 10) {
    //   tickInterval = 0.01;
    // }
    // if (maxPrice > 10000) {
    //   tickInterval = 10;
    // }
    // if (maxPrice <= 10000 && minPrice >= 1000) {
    //   tickInterval = 1;
    // } else {
    //   tickInterval = 0.1;
    // }

    // const min = (Math.floor(minPrice / tickInterval) * tickInterval) / 1000;
    // const max = (Math.ceil(maxPrice / tickInterval) * tickInterval) / 1000;
    const min = Math.floor(minPrice);
    const max = Math.ceil(maxPrice);

    return { min, max };
  };

  const yAxisOptions = getYAxisOptions(data);

  const chartOptions = {
    title: {
      text: ""
    },
    xAxis: {
      categories: data.map((item) => dayjs(new Date(item.date)).format("M.YY"))
    },
    yAxis: {
      ...yAxisOptions,
      title: {
        text: null
      }
    },
    series: [
      {
        name: "Price",
        data: data.map((item) => parseFloat(item.price)),
        // const prices = data.map((item) => parseFloat(item.price));
        // const maxPrice = Math.max(...prices);
        // if (maxPrice > 10000) {
        //   return parseFloat(item.price) / 1000;
        // }
        // Divide by 1000 to normalize for display
        // data: data.map((item) => parseFloat(item.price) / 1000), // Divide by 1000 to normalize for display
        color: "#4bc0c0",
        marker: {
          enabled: true,
          radius: 4,
          fillColor: "white",
          lineColor: "#4bc0c0",
          lineWidth: 2
        }
      }
    ],
    chart: {
      type: "line",
      height: "150px"
    },
    tooltip: {
      formatter: function () {
        // Multiply the displayed value by 1000 to show the original price
        // <span style="color: #4bc0c0">\u25CF</span>\nPrice: ${formattedValue(((this.y as number) * 1000).toFixed(2))}
        return `
        <span style="color: #4bc0c0">\u25CF</span>\nPrice: ${formattedValue(this.y as number)}
        <br/>
        &nbsp;&nbsp;<span>Date: ${this.x}<span/>`;
      },
      backgroundColor: "#ffffff",
      borderColor: "#4bc0c0",
      borderRadius: 10,
      borderWidth: 1,
      style: {
        color: "#333333",
        fontSize: "12px"
      }
    } as Highcharts.Options["tooltip"],
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default LineChart;
